<template>
  <div class="container">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <p v-if="message.data.meta" class='sc-message--meta' :style="{color: messageColors.color}">{{message.data.meta}}</p>
    </div>
    <div id="carousel-container" ref="carouselContainer">
      <div class="carousel-scroll" :style="`width: ${scrollItemWidth}px; margin-left: -${scrollPosition}px;`">
        <Insurance v-for="(option, idx) in options" :key="idx" :itemWidth="itemWidth" :option="option" :chatbotColors="chatbotColors" :optionSelected="optionSelected" :saberMais="saberMais" @selectOption="selectOption" @queroSaberMais="queroSaberMais" />
      </div>
    </div>
    <div class="carousel-pages">
      <a href="#" :style="carouselPage === i ? `width: 20px; background-color: ${chatbotColors.sentMessage.bg}; cursor: default;` : ''" @click.prevent="() => setCarouselPage(i)" v-for="i in numberLastPage" :key="`carousel-page-${i}`"></a>
    </div>
    <div class="carousel-pages-arrows">
      <button type="button" :disabled="disableDecrementCarouselPage" @click.prevent="decrementCarouselPage" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }">
        Anterior
      </button>
      <button type="button" :disabled="disableIncrementCarouselPage" @click.prevent="incrementCarouselPage" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }">
        Próximo
      </button>
    </div>
    <div class="total-resultados">{{ totalItemsMessage }}</div>
  </div>
</template>

<script>
import escapeGoat from 'escape-goat'
import store from "./../store/"
import Insurance from '../components/yupin/argo/rc-advogados-pf/Insurance.vue'

export default {
  components: {
    Insurance
  },
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
      options: [],
      carouselContainerOffsetWidth: 0,
      carouselPage: 1,
      optionSelected: null,
      saberMais: false,
    }
  },
  computed: {
    itemWidth() {
      return this.carouselContainerOffsetWidth / this.itemsPerPage;
    },
    scrollItemWidth() {
      return this.itemWidth * this.totalItems;
    },
    scrollPosition() {
      return this.itemWidth * (this.carouselPage - 1);
    },
    numberLastPage() {
      return this.totalItems - this.itemsPerPage + 1;
    },
    itemsPerPage() {
      return this.carouselContainerOffsetWidth < 500 ? 1 : 2;
    },
    totalItems() {
      return this.options.length;
    },
    totalItemsMessage() {
      return this.totalItems === 1
        ? `* Foi encontrado ${this.totalItems} plano`
        : `* Foram encontrados ${this.totalItems} planos`;
    },
    disableDecrementCarouselPage() {
      return this.carouselPage === 1;
    },
    disableIncrementCarouselPage() {
      return (this.carouselPage + this.itemsPerPage - 1) === this.totalItems;
    },
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    },
  },
  mounted() {
    this.options = this.message.data.options;

    this.setCarouselContainerOffsetWidth();
    window.addEventListener('resize', this.setCarouselContainerOffsetWidth);

    window.EventBus.$on('FULLSCREEN', () => {
      setTimeout(this.setCarouselContainerOffsetWidth, 700)
    });
  },
  methods: {
    setCarouselContainerOffsetWidth() {
      this.carouselContainerOffsetWidth = this.$refs.carouselContainer.offsetWidth;
      this.carouselPage = 1;
    },
    decrementCarouselPage() {
      this.carouselPage = this.carouselPage === 1 ? this.numberLastPage : this.carouselPage - 1;
    },
    incrementCarouselPage() {
      this.carouselPage = (this.carouselPage + this.itemsPerPage - 1) === this.totalItems ? 1 : this.carouselPage + 1;
    },
    setCarouselPage(page) {
      this.carouselPage = page;
    },
    selectOption (option) {
      this.optionSelected = option;

      const text = `<strong>Plano: </strong>${option.nome}<br><strong>Valor: </strong>${option.valor_pre_descricao}${option.valor}${option.valor_pos_descricao}`;

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        bot: true,
        data: { key: null, text, metadata: option }
      });
    },
    queroSaberMais (text) {
      this.saberMais = true;

      window.EventBus.$emit('ON_MESSAGE_WAS_SENT', {
        author: 'me',
        type: 'text',
        bot: true,
        data: { key: null, text, metadata: { saberMais: true } }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
  overflow: hidden;
}
#carousel-container {
  max-width: 100%;
  margin-top: 10px;
}
.carousel-scroll {
  display: flex;
  transition: all 0.3s ease-out;
}
.carousel-pages {
  max-width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 10px;

  a {
    display: inline-block;
    width: 10px;
    height: 7px;
    border: none;
    border-radius: 5px;
    margin: 0 3px 5px;
    outline: none;
    transition: all 0.2s ease-in-out;
    background: #ccc;

    &:focus {
      outline: none;
    }
  }
}
.carousel-pages-arrows {
  max-width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;

  button {
    display: inline-block;
    margin: 0 5px;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    -webkit-font-smoothing: subpixel-antialiased;
    border: 0;
    text-decoration: none;

    &:hover {
      opacity: .8;
      cursor: pointer;
    }
    &:disabled {
      opacity: .3;
      cursor: default;
    }
  }
}
.total-resultados {
  max-width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  font-size: .7rem;
}
</style>
